import { render, staticRenderFns } from "./goodsspu.vue?vue&type=template&id=22a4fd69&"
import script from "./goodsspu.vue?vue&type=script&lang=js&"
export * from "./goodsspu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22a4fd69')) {
      api.createRecord('22a4fd69', component.options)
    } else {
      api.reload('22a4fd69', component.options)
    }
    module.hot.accept("./goodsspu.vue?vue&type=template&id=22a4fd69&", function () {
      api.rerender('22a4fd69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/goodsspu/goodsspu.vue"
export default component.exports